import { GetServerSideProps } from 'next';

import client from 'api/apollo-client';
import {
	Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
	Enum_Componentinternaldefaultmoduleoptions_Padding,
	NewsletterArchiveOverviewSingleFieldsFragment,
	PageInformationFieldsFragment
} from 'api/graphql-types';
import { IBasePageProps } from 'types/page';

import { initialState as settingsInitialState } from 'redux/stores/settings';
import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import { ROUTES } from 'constants/routes';

import { getServerPageGetArchiveNewsletterOverview } from 'api/graphql-helper';
import IntroHeader from 'modules/intro-header/intro-header';
import { BaseModule } from 'modules/base-module/base-module';
import { Head } from 'modules/head/head';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import Layout from 'modules/layout/layout';
import NewsletterArchive from 'modules/newsletter-archive/newsletter-achive';

interface INewsletterArchivePublicPageProps extends IBasePageProps {
	pageInformation?: {
		data: {
			attributes: PageInformationFieldsFragment;
		};
	};
	newsletterArchiveOverview?: {
		data: {
			attributes: NewsletterArchiveOverviewSingleFieldsFragment;
		};
	};
}

const NewsletterArchivePage = ({
	pageInformation,
	newsletterArchiveOverview
}: INewsletterArchivePublicPageProps): React.JSX.Element => {
	const headerDefaultOptions = {
		backgroundColor: newsletterArchiveOverview?.data?.attributes?.header
			?.backgroundColor as Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
		padding: 'none' as Enum_Componentinternaldefaultmoduleoptions_Padding
	};

	return (
		<Layout navbar={pageInformation?.data?.attributes?.navbar} footer={pageInformation?.data?.attributes?.footer}>
			<Head
				seoModule={newsletterArchiveOverview?.data?.attributes?.seo}
				seoParent={pageInformation?.data?.attributes?.seo}
			/>
			<BaseModule defaultModuleOptions={headerDefaultOptions}>
				<IntroHeader
					module={{
						title: newsletterArchiveOverview?.data?.attributes?.header?.title || '',
						backgroundColor: newsletterArchiveOverview?.data?.attributes?.header?.backgroundColor,
						excerpt: newsletterArchiveOverview?.data?.attributes?.header?.excerpt || ''
					}}
					slug={ROUTES.NEWSLETTER_ARCHIVE.fullPath}
				/>
			</BaseModule>
			<BaseModule
				defaultModuleOptions={{
					backgroundColor: 'white',
					padding: 'medium'
				}}
			>
				<NewsletterArchive isGelderland />
			</BaseModule>
			<ModuleBuilder
				modules={newsletterArchiveOverview?.data?.attributes?.modules || []}
				slug={ROUTES.NEWSLETTER_ARCHIVE.fullPath}
			/>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps<any> = async (ctx) => {
	try {
		const { locale, publicationState, draftMode } = getStrapiParametersFromContext(ctx);

		const result = await getServerPageGetArchiveNewsletterOverview(
			{
				variables: {
					locale,
					publicationState
				}
			},
			client
		);

		const { pageInformation, newsletterArchiveOverview } = result.props.data;

		if (!newsletterArchiveOverview) {
			return {
				notFound: true,
				props: {
					initialReduxState: {
						settings: {
							...settingsInitialState,
							publicationState,
							draftMode
						}
					}
				}
			};
		}

		return {
			props: {
				pageInformation,
				newsletterArchiveOverview,
				initialReduxState: {
					settings: {
						...settingsInitialState,
						publicationState,
						draftMode,
						contentType: 'newsletter-archive'
					}
				}
			}
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in nieuwsbrief archief', error);

		return {
			notFound: true
		};
	}
};

export default NewsletterArchivePage;
